export enum RequirementStatus {
  Avventer = 'Avventer',
  Mangler = 'Mangler',
  Gyldig = 'Gyldig',
  Utgått = 'Utgått',
}

export type AddInfoParams = { applicationUid: string; attachmentGroup: string };
